import { awaitRequests, promise } from '../../../helpers';
import { exportAllActivities } from '../model-courses';

const addFacilitatorsGroupsItem = ({ data }) => {
    return (dispatch, getState, getFirebase) => {
        // -- add
        const add = d => {
            return getFirebase()
                .firestore()
                .collection('facilitatorsGroups')
                .add(d)
                .then(docRef => promise({ ...d, id: docRef.id }));
        };

        // after add
        const afterAdd = item => {
            const reqs = [];

            if (item.initialDate) {
                reqs.push(
                    dispatch(
                        exportAllActivities({
                            fromCourseId: item.courseId,
                            toGroupId: item.groupId,
                            initialDate: item.initialDate,
                        }),
                    ),
                );
            }

            return awaitRequests(reqs).then(() => promise(item));
        };

        // --
        if (data) {
            return add(data).then(item => afterAdd(item));
        }

        return promise();
    };
};

export default addFacilitatorsGroupsItem;
